export const actions = {
  async fetchLatestSong({ commit, state }) {
    const url = `//ws.audioscrobbler.com/2.0/?method=user.getrecenttracks&user=${state.username}&api_key=${state.apikey}&format=json`;

    fetch(url)
      .then(response => response.json())
      .then(data => {
        const artist = data.recenttracks.track[0].artist["#text"];
        const song = data.recenttracks.track[0].name;
        commit("setTrack", { artist: artist, song: song });
      })
      .catch(error => {
        commit("setError", error);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  }
};
